import { api } from '@config/api';
import type { Campanha, CampanhaInput } from '../types/Campanha';
import type { Progresso, ProgressoDaLista } from '../types/Progresso';

export const campanhasService = {
  listar: () => api.get<{ itens: Campanha[] }>('/campanhas').then((r) => r.data.itens),
  obter: (id: string) => api.get<Campanha>(`/campanhas/${id}`).then((r) => r.data),
  criar: (input: CampanhaInput) => api.post<Campanha>('/campanhas', input).then((r) => r.data),
  editar: (id: string, input: Partial<CampanhaInput>) =>
    api.patch<Campanha>(`/campanhas/${id}`, input).then((r) => r.data),
  /** `substituir`: a ativa que esta troca por si, atomicamente (spec 28 R9). */
  ativar: (id: string, substituir?: string) =>
    api.post<Campanha>(`/campanhas/${id}/ativar`, { substituir }).then((r) => r.data),
  desativar: (id: string) => api.post<Campanha>(`/campanhas/${id}/desativar`).then((r) => r.data),
  ativa: () =>
    api
      .get<{ campanha: { id: string; nome: string } | null }>('/campanhas/ativa')
      .then((r) => r.data.campanha),
  /** Spec 33 R19: rota pública, para o login; só campanhas agendadas ou abertas. */
  nomePublico: (id: string) =>
    api.get<{ nome: string }>(`/campanhas/${id}/publico`).then((r) => r.data.nome),
  /** Spec 34 R5: grava só a primeira vez; `204`. */
  marcarTextoRevisado: (id: string) =>
    api.post(`/campanhas/${id}/texto-revisado`).then(() => undefined),
  progresso: (id: string) => api.get<Progresso>(`/campanhas/${id}/progresso`).then((r) => r.data),
  progressoTodas: () =>
    api.get<{ itens: ProgressoDaLista[] }>('/progresso-campanhas').then((r) => r.data.itens),
};
